import Logo from "@/components/icons/Logo";
import AuthProcess from "@/panel/auth/AuthProcess";
import { FormState } from "@/stores/authStore";
import { useNavigate } from "react-router";

export default function LoginPage() {
  const navigate = useNavigate();

  const onVerified = () => {
    navigate("/dashboard");
  };
  return (
    <div className="h-screen w-screen flex justify-center items-center bg-brand-neutral-900">
      <div className="rounded-xl shadow-lg p-4 flex flex-col items-center gap-6 w-full h-full overflow-scroll">
        <Logo />
        <AuthProcess
          onVerified={onVerified}
          defaultFormState={FormState.SIGNIN}
        />
      </div>
    </div>
  );
}
